// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Account = (props) => {
  const {
    loggedIn,
    onClick,
    firstName,
    expanded,
  } = props;
  if (loggedIn) {
    return (
      <button
        className={`account ${expanded ? 'active' : ''}`}
        onClick={onClick}
      >
        <FontAwesomeIcon icon={['fas', 'user']} />
        {firstName}
        <FontAwesomeIcon icon={['fas', 'caret-down']} />
      </button>
    );
  }
  return (
    <NavLink activeClassName="is-active" exact to="/login">
      <button className="account">
        <FontAwesomeIcon icon={['fas', 'user']} />
        {firstName}
      </button>
    </NavLink>
  );
};

export default Account;

Account.propTypes = {
  loggedIn: PropTypes.bool,
  onClick: PropTypes.func,
  firstName: PropTypes.string,
  expanded: PropTypes.bool,
};

Account.defaultProps = {
  loggedIn: false,
  expanded: false,
  firstName: 'User',
  onClick: () => {
    this.setState(prevState => ({
      accountToggle: !prevState.burgerToggle,
    }));
  },
};
